<template>
	<div class="Home">
		<div class="hero">
			<div class="hero-content">
				<div class="hero-title">
					<h1>{{ $t('home.absatz1.title1') }}</h1>
					<h1>{{ $t('home.absatz1.title1a') }}</h1>
				</div>
				<div>
					{{ $t('home.absatz1.description.absatz1') }}
				</div>
				<div class="hero-button">
					<yellow-button
						:title="$t('home.absatz1.description.absatz2')"
						pathName="DasSystem"
					/>
				</div>
			</div>
		</div>

		<div class="content">
			<div class="kampfphasen">
				<div class="kampfphasen-einleitung">
					<div>
						<h1>{{ $t('home.absatz3.title') }}</h1>
						<div class="system-description">
							{{ $t('home.absatz3.description.absatz1') }}<br />
							{{ $t('home.absatz3.description.absatz2') }}
						</div>
					</div>
				</div>
				<fight-phases />
				<div class="system-action-button">
					<yellow-button
						:title="$t('home.absatz7.button1')"
						pathName="Ausbildungsgrade"
					/>
				</div>
			</div>
			<div class="systematik-viewport">
				<div class="systematik">
					<div class="systematik-wrapper">
						<h1>{{ $t('home.absatz2.description.title1') }}</h1>
						<div>{{ $t('home.absatz2.description.absatz2') }}</div>
						<div>{{ $t('home.absatz2.description.absatz2a') }}</div>
						<div class="system-action-button">
							<yellow-button
								:title="$t('home.absatz7.button2')"
								pathName="Aufbau"
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="wissenschaft-viewport">
				<div class="wissenschaft-viewport-h1">
					<h1>{{ $t('home.absatz2.description.title2') }}</h1>
				</div>
				<div class="wissenschaft-content">
					<div class="wissenschaft">
						<div>
							<div>{{ $t('home.absatz2.description.absatz3') }}</div>
							<div>{{ $t('home.absatz2.description.absatz4') }}</div>
						</div>
						<div class="wissenschaft-img"><img :src="editorial6Img" /></div>
					</div>
				</div>
				<div class="system-action-button">
					<yellow-button
						:title="$t('home.absatz7.button3')"
						pathName="Editorial6"
					/>
				</div>
			</div>
			<div class="methode-zweifel-absatz-viewport">
				<div class="methode-zweifel-absatz-viewport-h1">
					<h1>{{ $t('home.absatz9.title') }}</h1>
				</div>
				<div class="methode-zweifel-absatz-content">
					<div class="methode-zweifel-absatz">
						<div>
							<div>{{ $t('home.absatz9.absatz1') }}</div>
							<div>
								{{ $t('home.absatz9.absatz2') }}
								<router-link :to="{ name: 'Editorial2' }">{{
									$t('home.absatz9.absatz2a')
								}}</router-link>
							</div>

							<div>{{ $t('home.absatz9.absatz3') }}</div>
							<div>{{ $t('home.absatz9.absatz4') }}</div>
							<div>{{ $t('home.absatz9.absatz5') }}</div>
						</div>
						<div class="methode-zweifel-absatz-img">
							<img :src="editorial2Img" />
						</div>
					</div>
				</div>
				<div class="system-action-button">
					<yellow-button
						:title="$t('home.absatz7.button1')"
						pathName="Ausbildungsgrade"
					/>
				</div>
			</div>

			<div class="home-additional">
				<h1>{{ $t('home.absatz8.title') }}</h1>
				<div class="additional-buttons">
					<div class="additional-button">
						<secondary-button
							:title="$t('home.absatz8.button1')"
							pathName="Kontakt"
						/>
					</div>
					<div class="additional-button">
						<secondary-button
							:title="$t('home.absatz8.button2')"
							pathName="Editorial"
						/>
					</div>
					<div class="additional-button">
						<secondary-button
							:title="$t('home.absatz8.button3')"
							pathName="FAQ"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import editorial2 from '@/assets/editorial/editorial2.jpg'
import editorial6 from '@/assets/editorial/editorial6.jpg'

import FightPhases from '@/components/FightPhases.vue'
import YellowButton from '@/components/YellowButton.vue'
import SecondaryButton from '@/components/SecondaryButton.vue'

export default {
	name: 'Home',
	components: {
		FightPhases,
		YellowButton,
		SecondaryButton
	},
	data() {
		return {
			editorial2Img: editorial2,
			editorial6Img: editorial6
		}
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_startseite.json'),
			en: require('@/i18n/en/eng_startseite.json')
		}
	}
}
</script>

<style scoped lang="styl">
.hero {
	position: relative;
	background: url('../../assets/home/2025499475.jpg') no-repeat;
	background-size: cover;
	width: 100%;
	height: 100vh;
}
.hero-content {
	width: clamp(200px, 100vw, 850px);
	position: absolute;
	bottom: 45px;
	background: rgba(0,0,0,0.2);
    padding: 40px;
}
.hero-title {
	margin-bottom: 7vh;
	text-transform: uppercase;
}
.hero-title h1 {
	color: #E5E41A;
	border: none;
	font-size: 3rem;
	padding: 0;
	margin: 0;
}
.hero-button {
	margin-top: 6vh;
}

.hero-button,
.additional-buttons,
.system-action-button {
	display: flex;
	justify-content: center;
}

.additional-button button:hover {
	box-shadow: 1px 2px 1px rgba(255,255,255,0.75);
	transform: translateY(-3px);
}
.content {
	background-color: #000;
}
.kampfphasen-einleitung,
.systematik-viewport,
.wissenschaft-viewport,
.methode-zweifel-absatz-viewport {
	padding: 0 50px 0 40px;
}

.kampfphasen .system-description {
	margin-bottom: 10vh;
}

.systematik-viewport,
.wissenschaft-viewport,
.methode-zweifel-absatz-viewport {
	height: 100vh;
}
.systematik-viewport, .wissenschaft-content, .methode-zweifel-absatz-content {
	display: flex;
	justify-content: center;
	align-items: center;
}
.systematik,
.kampfphasen-einleitung,
.wissenschaft-viewport-h1,
.methode-zweifel-absatz-viewport-h1 {
	display: flex;
	justify-content: center;
}
.systematik div,
.kampfphasen-einleitung div,
.wissenschaft-viewport-h1 h1,
.methode-zweifel-absatz-viewport-h1 h1 {
	flex-basis: 1100px;
}
.wissenschaft,
.methode-zweifel-absatz {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
}
.wissenschaft div,
.methode-zweifel-absatz div {
	flex-basis: 525px;
	align-self: center;
}
.wissenschaft-img,
.methode-zweifel-absatz-img {
	display: flex;
	justify-content: center;
	margin-left: 50px;
}
.wissenschaft-img img,
.methode-zweifel-absatz-img img {
	width: 100%;
}

.kampfphasen h1 {
	margin-bottom: 4vh;
}
.systematik-viewport h1,
.wissenschaft-viewport h1,
.methode-zweifel-absatz-viewport h1 {
	padding-top: 0;
	margin-bottom: 4vh;
}

.methode-zweifel-absatz div > div,
.wissenschaft div > div,
.systematik div > div {
	margin-bottom: 2vh;
}

@media only screen and (min-width: 1500px) {
	.wissenschaft div,
.methode-zweifel-absatz div {
	flex-basis: 650px;
}
.systematik div,
.kampfphasen-einleitung div,
.wissenschaft-viewport-h1 h1,
.methode-zweifel-absatz-viewport-h1 h1 {
	flex-basis: 1400px;
}
}
@media only screen and (max-width: 1189px) {
	.systematik div,
	.wissenschaft div,
	.methode-zweifel-absatz div {
		flex-basis: 850px;
	}
	.wissenschaft-img,
	.methode-zweifel-absatz-img {
		margin-top: 5vh;
	}
	.wissenschaft div img,
	.methode-zweifel-absatz div img {
		height: 50vh;
		width: unset;
	}
.wissenschaft-viewport {
	height: 180vh;
}
	.systematik-viewport {
	height: 120vh;
}
.methode-zweifel-absatz-viewport {
	height: 160vh;
}
}
@media only screen and (max-width: 912px) {
	.home-additional .additional-buttons .additional-button {
		padding: 0;
	}
	.hero {
		height: 65vh;
		background-position: bottom;
	}
	.hero-content {
		bottom: 0;
	}
	.hero-title h1 {
		font-size: 2.8rem;
	}
	.systematik-viewport {
		height: 60vh;
	}
	.wissenschaft-viewport {
		height: 112vh;
	}
	.methode-zweifel-absatz-viewport {
		height: 110vh;
	}
}
@media only screen and (max-width: 820px) {
	.home-additional .additional-buttons .additional-button {
		padding: 0;
	}
	.hero {
		height: 95vh;
		background-position: bottom;
	}
	.hero-content {
		bottom: 0;
	}
	.hero-title h1 {
		font-size: 2.8rem;
	}
	.systematik-viewport {
		height: 75vh;
	}
	.wissenschaft-viewport {
		height: 125vh;
	}
	.methode-zweifel-absatz-viewport {
		height: 124vh;
	}

	
}

@media only screen and (max-width: 540px) {
	.hero {
		height: 99vh;
	}
	.hero-content {
		bottom: 26px;
	}
	.hero-title h1 {
		font-size: 2.6rem;
	}
	.system-action-button, .additional-button {
		max-width: 450px;
		margin-left: 45px;
		margin-right: 45px;
	}
	.additional-button {
		max-width: 460px;
		margin-left: 0;
		margin-right: 0;
	}
	.systematik-wrapper .system-action-button,
	.methode-zweifel-absatz-viewport .system-action-button {
		max-width: 450px;
		margin-left: 0;
		margin-right: 0;
		flex-basis: 0;
	}
	.systematik-wrapper {
		width: 420px;
	}
	.wissenschaft div:first-child, .methode-zweifel-absatz div {
		flex-basis: 450px;
	}
	.systematik-viewport {
		height: 135vh;
	}
	.wissenschaft-viewport {
		height: 190vh;
	}
	.methode-zweifel-absatz-viewport {
		height: 180vh;
	}
	.content .home-additional {
		width: 450px;
		padding: 0;
		margin: 0 40px;
	}
	.systematik div,
	.wissenschaft div,
	.methode-zweifel-absatz div {
		flex-basis: 450px;
	}
	.wissenschaft div img,
	.methode-zweifel-absatz div img {
		height: 50vh;
		width: unset;
	}
	.wissenschaft-img,
	.methode-zweifel-absatz-img {
		display: flex;
		justify-content: center;
		margin-left: 0px;
	}
}
@media only screen and (max-width: 414px) {
	.hero {
		height: 90vh;
	}
	.hero-content {
		bottom: 8px;
	}
	.system-action-button, .additional-button {
		max-width: 400px;
		margin-left: 45px;
		margin-right: 45px;
	}
	.additional-button {
		max-width: 340px;
		margin-left: 0;
		margin-right: 0;
	}
	.systematik-wrapper .system-action-button,
	.methode-zweifel-absatz-viewport .system-action-button {
		max-width: 400px;
		margin-left: 0;
		margin-right: 0;
		flex-basis: 0;
	}
	.systematik-wrapper {
		width: 320px;
	}
	.wissenschaft div:first-child, .methode-zweifel-absatz div {
		flex-basis: 400px;
	}
	.systematik-viewport {
		height: 112vh;
	}
	.wissenschaft-viewport {
		height: 165vh;
	}
	.methode-zweifel-absatz-viewport {
		height: 155vh;
	}
	.content .home-additional {
		width: 340px;
		padding: 0;
		margin: 0 35px;
	}
	.systematik div,
	.wissenschaft div,
	.methode-zweifel-absatz div {
		flex-basis: 400px;
	}
	.wissenschaft div img,
	.methode-zweifel-absatz div img {
		height: 32vh;
		width: unset;
	}
	.wissenschaft-img,
	.methode-zweifel-absatz-img {
		display: flex;
		justify-content: center;
		margin-left: 0px;
	}
}
@media only screen and (max-width: 393px) {
	.hero {
		height: 100vh;
	}
	.hero-content {
		bottom: 16px;
	}
	.system-action-button, .additional-button {
		max-width: 400px;
		margin-left: 45px;
		margin-right: 45px;
	}
	.additional-button {
		max-width: 340px;
		margin-left: 0;
		margin-right: 0;
	}
	.systematik-wrapper .system-action-button,
	.methode-zweifel-absatz-viewport .system-action-button {
		max-width: 400px;
		margin-left: 0;
		margin-right: 0;
		flex-basis: 0;
	}
	.systematik-wrapper {
		width: 320px;
	}
	.wissenschaft div:first-child, .methode-zweifel-absatz div {
		flex-basis: 300px;
	}
	.systematik-viewport {
		height: 112vh;
	}
	.wissenschaft-viewport {
		height: 180vh;
	}
	.methode-zweifel-absatz-viewport {
		height: 175vh;
	}
	.content .home-additional {
		width: 340px;
		padding: 0;
		margin: 0 35px;
	}
}
@media only screen and (max-width: 375px) {
	.hero {
		height: 135vh;
	}
	.hero-content {
		bottom: 16px;
	}
	.system-action-button, .additional-button {
		max-width: 300px;
		margin-left: 45px;
		margin-right: 45px;
	}
	.systematik-wrapper .system-action-button {
		max-width: 300px;
		margin-left: 0;
		margin-right: 0;
		flex-basis: 0;
	}
	.systematik-wrapper {
		width: 280px;
	}
	.wissenschaft div:first-child, .methode-zweifel-absatz div {
		flex-basis: 300px;
	}
	.systematik-viewport {
		height: 140vh;
	}
	.wissenschaft-viewport {
		height: 215vh;
	}
	.methode-zweifel-absatz-viewport {
		margin-bottom: 34vh;
		height: 176vh;
	}
	.content .home-additional {
		width: 300px;
		padding: 0;
		margin: 0 25px;
	}
}
@media only screen and (max-width: 360px) {
	.hero {
		height: 120vh;
	}
	.hero-content {
		bottom: 6px;
	}
	.system-action-button, .additional-button {
		max-width: 300px;
		margin-left: 45px;
		margin-right: 45px;
	}
	.systematik-wrapper .system-action-button {
		max-width: 300px;
		margin-left: 0;
		margin-right: 0;
		flex-basis: 0;
	}
	.systematik-wrapper {
		width: 280px;
	}
	.wissenschaft div:first-child, .methode-zweifel-absatz div {
		flex-basis: 300px;
	}
	.systematik-viewport {
		height: 140vh;
	}
	.wissenschaft-viewport {
		height: 215vh;
	}
	.methode-zweifel-absatz-viewport {
		margin-bottom: 22vh;
		height: 176vh;
	}
	.content .home-additional {
		width: 300px;
		padding: 0;
		margin: 0 25px;
	}
}
@media only screen and (max-width: 280px) {
	.hero {
		height: 120vh;
	}
	.hero-content {
		bottom: 6px;
	}
	.system-action-button, .additional-button {
		max-width: 200px;
	}
	.systematik-wrapper .system-action-button {
		max-width: 200px;
		margin-left: 0;
		margin-right: 0;
		flex-basis: 0;
	}
	.systematik-wrapper {
		width: 200px;
	}
	.content h1 {
		font-size: 1.8rem;
	}
	.wissenschaft div:first-child, .methode-zweifel-absatz div {
		flex-basis: 200px;
	}
	.systematik-viewport {
		height: 160vh;
	}
	.wissenschaft-viewport {
		height: 248vh;
	}
	.methode-zweifel-absatz-viewport {
		margin-bottom: 22vh;
		height: 205vh;
	}
	.content .home-additional {
		width: 250px;
		padding: 0;
		margin: 0 25px;
	}
	.systematik div,
	.wissenschaft div,
	.methode-zweifel-absatz div {
		flex-basis: 180px;
	}
	.wissenschaft div img,
	.methode-zweifel-absatz div img {
		height: 30vh;
		width: unset;
	}
	.wissenschaft-img,
	.methode-zweifel-absatz-img {
		display: flex;
		justify-content: center;
		margin-left: 0px;
	}
}

.additional-buttons {
	flex-wrap: wrap;
	margin: 5vh 0 15vh 0;
}
.additional-button {
	display: flex;
	justify-content: center;
    padding: 0 50px 0 40px;
	margin-bottom: 4vh;
}

.home-additional {
	padding: 0 50px 0 40px;
}

.system-action-button {
	margin-top: 4vh;
}

.additional-button button a {
	color: white;
}
button a {
	color: black;
}
</style>
